export const timeZoneToCountryCode: { [key: string]: string } = {
    // Americas
    "America/New_York": "us",
    "America/Chicago": "us",
    "America/Denver": "us",
    "America/Los_Angeles": "us",
    "America/Toronto": "ca",
    "America/Vancouver": "ca",
    "America/Mexico_City": "mx",
    "America/Sao_Paulo": "br",
    "America/Argentina/Buenos_Aires": "ar",
    "America/Bogota": "co",
    "America/Lima": "pe",
    "America/Caracas": "ve",
    "America/Santiago": "cl",
    "America/Montevideo": "uy",
    "America/La_Paz": "bo",
    "America/Panama": "pa",
    "America/Guatemala": "gt",
    "America/Havana": "cu",
    "America/Puerto_Rico": "pr",
    "America/Anchorage": "us",
    "America/Honolulu": "us",

    // Europe
    "Europe/London": "gb",
    "Europe/Paris": "fr",
    "Europe/Berlin": "de",
    "Europe/Madrid": "es",
    "Europe/Rome": "it",
    "Europe/Warsaw": "pl",
    "Europe/Amsterdam": "nl",
    "Europe/Brussels": "be",
    "Europe/Vienna": "at",
    "Europe/Stockholm": "se",
    "Europe/Copenhagen": "dk",
    "Europe/Lisbon": "pt",
    "Europe/Helsinki": "fi",
    "Europe/Dublin": "ie",
    "Europe/Budapest": "hu",
    "Europe/Prague": "cz",
    "Europe/Athens": "gr",
    "Europe/Sofia": "bg",
    "Europe/Belgrade": "rs",
    "Europe/Moscow": "ru",
    "Europe/Kiev": "ua",
    "Europe/Zurich": "ch",
    "Europe/Istanbul": "tr",

    // Asia
    "Asia/Tokyo": "jp",
    "Asia/Seoul": "kr",
    "Asia/Shanghai": "cn",
    "Asia/Hong_Kong": "hk",
    "Asia/Taipei": "tw",
    "Asia/Singapore": "sg",
    "Asia/Bangkok": "th",
    "Asia/Kuala_Lumpur": "my",
    "Asia/Jakarta": "id",
    "Asia/Manila": "ph",
    "Asia/Colombo": "lk",
    "Asia/Kolkata": "in",
    "Asia/Kathmandu": "np",
    "Asia/Dhaka": "bd",
    "Asia/Yangon": "mm",
    "Asia/Phnom_Penh": "kh",
    "Asia/Vientiane": "la",
    "Asia/Tashkent": "uz",
    "Asia/Tehran": "ir",
    "Asia/Riyadh": "sa",
    "Asia/Dubai": "ae",
    "Asia/Jerusalem": "il",
    "Asia/Amman": "jo",
    "Asia/Baghdad": "iq",
    "Asia/Beirut": "lb",
    "Asia/Karachi": "pk",
    "Asia/Ho_Chi_Minh": "vn",
    "Asia/Ulaanbaatar": "mn",

    // Africa
    "Africa/Cairo": "eg",
    "Africa/Johannesburg": "za",
    "Africa/Lagos": "ng",
    "Africa/Nairobi": "ke",
    "Africa/Accra": "gh",
    "Africa/Addis_Ababa": "et",
    "Africa/Dar_es_Salaam": "tz",
    "Africa/Algiers": "dz",
    "Africa/Casablanca": "ma",
    "Africa/Khartoum": "sd",
    "Africa/Luanda": "ao",
    "Africa/Maputo": "mz",
    "Africa/Tunis": "tn",
    "Africa/Windhoek": "na",

    // Oceania
    "Australia/Sydney": "au",
    "Australia/Melbourne": "au",
    "Australia/Brisbane": "au",
    "Australia/Perth": "au",
    "Pacific/Auckland": "nz",
    "Pacific/Fiji": "fj",
    "Pacific/Guam": "gu",
    "Pacific/Samoa": "ws",
    "Pacific/Tahiti": "pf",
    "Pacific/Port_Moresby": "pg",

    // Miscellaneous
    "Antarctica/Casey": "aq",
    "Etc/UTC": "un", // Use "un" or other default for non-country-specific zones
};
